<template>
  <p-vue-table
    :value="data"
    dataKey="keysID"
    class="p-datatable-sm"
    responsiveLayout="stack"
    breakpoint="450px"
  >
    <p-vue-column
      field="GroupName"
      :header="__('Maintenance area')"
      :sortable="true"
    ></p-vue-column>
    <p-vue-column
      field="KeyType"
      :header="__('Key type')"
      :sortable="true"
    ></p-vue-column>
    <p-vue-column
      field="AreaManagerCopy"
      :header="__('Copy to maintenance manager')"
      :sortable="true"
    >
      <template #body="{ data }">
        <i-icon name="done" v-if="data.AreaManagerCopy == true" />
      </template>
    </p-vue-column>
    <p-vue-column field="OfficeCopy" :header="__('Office copy')" :sortable="true"
      ><template #body="{ data }">
        <i-icon name="done" v-if="data.OfficeCopy == true" /> </template
    ></p-vue-column>
    <p-vue-column
      field="Comments"
      :header="__('Comments')"
      :sortable="true"
    ></p-vue-column>
  </p-vue-table>
</template>

<script>
export default {
  props: {
    data: Object,
  },
};
</script>

<style scoped>
:deep(.svg){
  width: 13px;
  height: 13px;
  margin-left: 4px;
}
</style>
